import SoftBadge from "components/SoftBadge";
import { useState, useEffect } from "react";
import ProductCell from "../components/ProductCell";
import ActionCell from "../components/ActionCell";
import { API_BASE_URL } from '../../../../../services/config.js';

// Badges 
const udsInactive = (
  <SoftBadge variant="contained" color="error" size="xs" badgeContent="Inaktiv" container />
);
const udsActive = (
  <SoftBadge variant="contained" color="success" size="xs" badgeContent="Aktiv" container />
);
const udsPending = (
  <SoftBadge variant="contained" color="warning" size="xs" badgeContent="Ausstehend" container />
);

const useDataTableData = () => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const fetchRows = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/saas-service`, {
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' }
        });
        
        if (!response.ok) {
          console.error("API returned ERROR:", response.statusText);
          setRows([]);
          return;
        }

        const data = await response.json();

        if (!data || data.length === 0) {
          setRows([]);
          return;
        }

        // Vereinfachte Verarbeitung, da wir wissen, dass die API ein Array zurückgibt
        const formattedRows = data.map((item) => {
          return {
            id: <ProductCell name={item.id} />, // Bild nur im ID-Feld
            hostname: item.hostname || "N/A",
            servicename: item.servicename || "N/A",
            status: item.sstatus === "active" ? udsActive : item.sstatus === "pending" ? udsPending : udsInactive,
            action: <ActionCell serviceId={item.id.toString()} />,
          };
        });

        setRows(formattedRows);
      } catch (error) {
        console.error("Error fetching rows:", error);
        setRows([]);
      }
    };

    fetchRows();
  }, []);

  const columns = [
    { Header: "ID", accessor: "id", align: "left" },
    { Header: "Hostname", accessor: "hostname" },
    { Header: "Service Name", accessor: "servicename" },
    { Header: "Status", accessor: "status" },
    { Header: "Action", accessor: "action" }
  ];

  return { columns, rows };
};

export default useDataTableData;
